module.exports = __webpack_public_path__ + "static/media/spotify.84da44a1.png";